var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopDesktopResultPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1284,
    height: 406,
    opacity: 0.8,
    viewBox: "0 0 1284 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6444 193.742C0.670599 220.613 -5.37219 254.169 6.2025 279.438C29.8228 330.981 98.8958 341.525 134.115 297.871C144.875 284.527 155.644 269.588 171.88 264.076C202.174 253.803 232.995 271.079 263.632 254.943C296.28 237.746 319.246 202.204 357.339 195.536C380.424 191.492 401.259 200.115 423.378 197.754C434.394 196.581 445.721 194.1 454.446 187.281C477.412 169.318 472.143 132.404 458.014 111.172C446.927 94.5172 430.331 81.9865 412.131 73.6434C370.717 54.652 323.54 64.6861 280.092 70.1179C254.052 73.3722 229.051 78.6126 203.14 81.8828C174.315 85.512 145.602 91.2788 118.381 101.632C81.3661 115.702 46.8975 138.857 24.7699 171.679C20.4034 178.156 16.2525 185.646 12.6444 193.749V193.742Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.895 204.359C383.211 206.042 383.187 208.746 384.815 210.461C386.188 208.06 387.425 205.612 388.543 203.115C387.242 202.948 385.885 203.362 384.887 204.359H384.895Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M378.7 216.739C376.992 215.032 374.222 215.032 372.506 216.739C370.798 218.445 370.798 221.221 372.506 222.928C373.232 223.654 374.142 224.069 375.092 224.172C376.729 222.282 378.277 220.344 379.722 218.35C379.506 217.76 379.171 217.209 378.7 216.731V216.739Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M366.311 229.118C364.602 227.411 361.832 227.411 360.116 229.118C358.408 230.825 358.408 233.6 360.116 235.307C360.659 235.85 361.314 236.225 362.008 236.416C363.908 234.972 365.768 233.441 367.572 231.822C367.484 230.833 367.061 229.867 366.303 229.118H366.311Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.923 241.497C352.214 239.79 349.444 239.79 347.728 241.497C346.579 242.645 346.203 244.265 346.603 245.724C349.165 244.528 351.679 243.196 354.138 241.728C354.066 241.648 354.002 241.569 353.923 241.497Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.014 170.508C396.014 170.285 396.03 170.07 396.03 169.846C396.006 170.07 395.998 170.285 396.014 170.508Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384.894 179.601C383.186 181.308 383.186 184.084 384.894 185.791C386.603 187.498 389.381 187.498 391.089 185.791C392.797 184.084 392.797 181.308 391.089 179.601C389.381 177.894 386.611 177.894 384.894 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M372.506 191.98C370.798 193.687 370.798 196.463 372.506 198.17C374.214 199.877 376.992 199.877 378.7 198.17C380.409 196.463 380.409 193.687 378.7 191.98C376.992 190.273 374.222 190.273 372.506 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M360.116 204.359C358.408 206.066 358.408 208.842 360.116 210.549C361.824 212.256 364.602 212.256 366.311 210.549C368.019 208.842 368.019 206.066 366.311 204.359C364.602 202.652 361.832 202.652 360.116 204.359Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.727 216.739C346.019 218.445 346.019 221.221 347.727 222.928C349.436 224.635 352.214 224.635 353.922 222.928C355.63 221.221 355.63 218.445 353.922 216.739C352.214 215.032 349.444 215.032 347.727 216.739Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.339 229.118C333.631 230.825 333.631 233.6 335.339 235.307C337.047 237.014 339.825 237.014 341.533 235.307C343.242 233.6 343.242 230.825 341.533 229.118C339.825 227.411 337.055 227.411 335.339 229.118Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.95 241.497C321.242 243.204 321.242 245.98 322.95 247.686C324.658 249.393 327.436 249.393 329.145 247.686C330.853 245.98 330.853 243.204 329.145 241.497C327.428 239.79 324.666 239.79 322.95 241.497Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.648 253.796C312.572 253.788 314.504 253.716 316.428 253.573C314.735 252.193 312.261 252.265 310.648 253.796Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M391.089 154.843C389.381 153.136 386.611 153.136 384.894 154.843C383.186 156.55 383.186 159.326 384.894 161.033C386.603 162.74 389.381 162.74 391.089 161.033C392.797 159.326 392.797 156.55 391.089 154.843Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M378.7 167.222C376.992 165.515 374.222 165.515 372.506 167.222C370.798 168.929 370.798 171.705 372.506 173.412C374.214 175.119 376.992 175.119 378.7 173.412C380.409 171.705 380.409 168.929 378.7 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M366.311 179.601C364.602 177.894 361.832 177.894 360.116 179.601C358.408 181.308 358.408 184.084 360.116 185.791C361.824 187.498 364.602 187.498 366.311 185.791C368.019 184.084 368.019 181.308 366.311 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M353.922 191.98C352.214 190.273 349.444 190.273 347.727 191.98C346.019 193.687 346.019 196.463 347.727 198.17C349.436 199.877 352.214 199.877 353.922 198.17C355.63 196.463 355.63 193.687 353.922 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M341.533 204.359C339.825 202.652 337.055 202.652 335.339 204.359C333.631 206.066 333.631 208.842 335.339 210.549C337.047 212.256 339.825 212.256 341.533 210.549C343.242 208.842 343.242 206.066 341.533 204.359Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M329.145 216.739C327.428 215.032 324.666 215.032 322.95 216.739C321.242 218.445 321.242 221.221 322.95 222.928C324.658 224.635 327.436 224.635 329.145 222.928C330.853 221.221 330.853 218.445 329.145 216.739Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M310.56 229.118C308.852 230.825 308.852 233.6 310.56 235.307C312.277 237.014 315.047 237.014 316.755 235.307C318.463 233.6 318.463 230.825 316.755 229.118C315.047 227.411 312.277 227.411 310.56 229.118Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.172 241.497C296.464 243.204 296.464 245.98 298.172 247.686C299.88 249.393 302.658 249.393 304.366 247.686C306.075 245.98 306.075 243.204 304.366 241.497C302.658 239.79 299.888 239.79 298.172 241.497Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M384.894 136.274C386.347 137.726 388.558 137.941 390.243 136.928C389.197 134.24 388.016 131.592 386.691 129C386.036 129.207 385.413 129.566 384.894 130.085C383.186 131.792 383.186 134.567 384.894 136.274Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M378.7 142.464C376.992 140.757 374.222 140.757 372.506 142.464C370.798 144.171 370.798 146.947 372.506 148.653C374.214 150.36 376.992 150.36 378.7 148.653C380.409 146.947 380.409 144.171 378.7 142.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M366.311 154.843C364.602 153.136 361.832 153.136 360.116 154.843C358.408 156.55 358.408 159.326 360.116 161.033C361.824 162.74 364.602 162.74 366.311 161.033C368.019 159.326 368.019 156.55 366.311 154.843Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M353.922 167.222C352.214 165.515 349.444 165.515 347.727 167.222C346.019 168.929 346.019 171.705 347.727 173.412C349.436 175.119 352.214 175.119 353.922 173.412C355.63 171.705 355.63 168.929 353.922 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M341.533 179.601C339.825 177.894 337.055 177.894 335.339 179.601C333.631 181.308 333.631 184.084 335.339 185.791C337.047 187.498 339.825 187.498 341.533 185.791C343.242 184.084 343.242 181.308 341.533 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.145 191.98C327.428 190.273 324.666 190.273 322.95 191.98C321.242 193.687 321.242 196.463 322.95 198.17C324.658 199.877 327.436 199.877 329.145 198.17C330.853 196.463 330.853 193.687 329.145 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.755 204.359C315.047 202.652 312.277 202.652 310.56 204.359C308.852 206.066 308.852 208.842 310.56 210.549C312.277 212.256 315.047 212.256 316.755 210.549C318.463 208.842 318.463 206.066 316.755 204.359Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 216.739C302.658 215.032 299.888 215.032 298.172 216.739C296.464 218.445 296.464 221.221 298.172 222.928C299.88 224.635 302.658 224.635 304.366 222.928C306.075 221.221 306.075 218.445 304.366 216.739Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M285.783 229.118C284.075 230.825 284.075 233.6 285.783 235.307C287.491 237.014 290.269 237.014 291.978 235.307C293.686 233.6 293.686 230.825 291.978 229.118C290.269 227.411 287.499 227.411 285.783 229.118Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M279.596 247.686C281.305 245.98 281.305 243.204 279.596 241.497C277.888 239.79 275.118 239.79 273.402 241.497C272.452 242.446 272.037 243.714 272.133 244.951C274.448 246.091 276.802 247.12 279.189 248.037C279.333 247.926 279.469 247.814 279.596 247.678V247.686Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M378.7 117.706C376.992 115.999 374.222 115.999 372.506 117.706C370.798 119.413 370.798 122.188 372.506 123.895C374.214 125.602 376.992 125.602 378.7 123.895C380.409 122.188 380.409 119.413 378.7 117.706Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M366.311 130.085C364.602 128.378 361.832 128.378 360.116 130.085C358.408 131.792 358.408 134.567 360.116 136.274C361.824 137.981 364.602 137.981 366.311 136.274C368.019 134.567 368.019 131.792 366.311 130.085Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M353.922 142.464C352.214 140.757 349.444 140.757 347.727 142.464C346.019 144.171 346.019 146.947 347.727 148.653C349.436 150.36 352.214 150.36 353.922 148.653C355.63 146.947 355.63 144.171 353.922 142.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M341.533 154.843C339.825 153.136 337.055 153.136 335.339 154.843C333.631 156.55 333.631 159.326 335.339 161.033C337.047 162.74 339.825 162.74 341.533 161.033C343.242 159.326 343.242 156.55 341.533 154.843Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M329.145 167.222C327.436 165.515 324.666 165.515 322.95 167.222C321.242 168.929 321.242 171.705 322.95 173.412C324.658 175.119 327.436 175.119 329.145 173.412C330.853 171.705 330.853 168.929 329.145 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M316.755 179.601C315.047 177.894 312.277 177.894 310.56 179.601C308.852 181.308 308.852 184.084 310.56 185.791C312.277 187.498 315.047 187.498 316.755 185.791C318.463 184.084 318.463 181.308 316.755 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 191.98C302.658 190.273 299.888 190.273 298.172 191.98C296.464 193.687 296.464 196.463 298.172 198.17C299.88 199.877 302.658 199.877 304.366 198.17C306.075 196.463 306.075 193.687 304.366 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M291.978 204.359C290.269 202.652 287.499 202.652 285.783 204.359C284.075 206.066 284.075 208.842 285.783 210.549C287.491 212.256 290.269 212.256 291.978 210.549C293.686 208.842 293.686 206.066 291.978 204.359Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M273.402 216.739C271.694 218.445 271.694 221.221 273.402 222.928C275.111 224.635 277.88 224.635 279.597 222.928C281.305 221.221 281.305 218.445 279.597 216.739C277.888 215.032 275.119 215.032 273.402 216.739Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M261.006 229.118C259.298 230.825 259.298 233.6 261.006 235.307C262.714 237.014 265.492 237.014 267.2 235.307C268.909 233.6 268.909 230.825 267.2 229.118C265.492 227.411 262.722 227.411 261.006 229.118Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M366.311 105.327C364.602 103.62 361.832 103.62 360.116 105.327C358.408 107.033 358.408 109.809 360.116 111.516C361.824 113.223 364.602 113.223 366.311 111.516C368.019 109.801 368.019 107.033 366.311 105.327Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M353.922 117.706C352.214 115.999 349.444 115.999 347.727 117.706C346.019 119.413 346.019 122.188 347.727 123.895C349.436 125.602 352.214 125.602 353.922 123.895C355.63 122.188 355.63 119.413 353.922 117.706Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M341.533 130.085C339.825 128.378 337.055 128.378 335.339 130.085C333.631 131.792 333.631 134.567 335.339 136.274C337.047 137.981 339.825 137.981 341.533 136.274C343.242 134.567 343.242 131.792 341.533 130.085Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M329.145 142.464C327.436 140.757 324.666 140.757 322.95 142.464C321.242 144.171 321.242 146.947 322.95 148.653C324.658 150.36 327.436 150.36 329.145 148.653C330.853 146.947 330.853 144.171 329.145 142.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M316.755 154.843C315.047 153.136 312.277 153.136 310.56 154.843C308.852 156.55 308.852 159.326 310.56 161.033C312.277 162.74 315.047 162.74 316.755 161.033C318.463 159.326 318.463 156.55 316.755 154.843Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 167.222C302.658 165.515 299.888 165.515 298.172 167.222C296.464 168.929 296.464 171.705 298.172 173.412C299.88 175.119 302.658 175.119 304.366 173.412C306.075 171.705 306.075 168.929 304.366 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M291.978 179.601C290.269 177.894 287.5 177.894 285.783 179.601C284.067 181.308 284.067 184.084 285.783 185.791C287.492 187.498 290.269 187.498 291.978 185.791C293.686 184.084 293.686 181.308 291.978 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 191.98C277.881 190.273 275.111 190.273 273.394 191.98C271.686 193.687 271.686 196.463 273.394 198.17C275.103 199.877 277.873 199.877 279.589 198.17C281.297 196.463 281.297 193.687 279.589 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M267.2 204.359C265.492 202.652 262.722 202.652 261.006 204.359C259.298 206.066 259.298 208.842 261.006 210.549C262.714 212.256 265.492 212.256 267.2 210.549C268.909 208.842 268.909 206.066 267.2 204.359Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.616 216.739C246.908 218.445 246.908 221.221 248.616 222.928C250.324 224.635 253.102 224.635 254.811 222.928C256.519 221.221 256.519 218.445 254.811 216.739C253.102 215.032 250.332 215.032 248.616 216.739Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M347.727 99.145C349.436 100.852 352.214 100.852 353.922 99.145C355.095 97.9725 355.463 96.2895 355.024 94.8059C353.291 93.7451 351.527 92.748 349.731 91.8148C348.997 92.0062 348.302 92.3811 347.727 92.9554C346.019 94.6623 346.019 97.4381 347.727 99.145Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M341.533 105.335C339.825 103.628 337.055 103.628 335.339 105.335C333.631 107.041 333.631 109.817 335.339 111.524C337.047 113.231 339.825 113.231 341.533 111.524C343.242 109.817 343.242 107.041 341.533 105.335Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M329.145 117.706C327.436 115.999 324.666 115.999 322.95 117.706C321.242 119.413 321.242 122.188 322.95 123.895C324.658 125.602 327.436 125.602 329.145 123.895C330.853 122.188 330.853 119.413 329.145 117.706Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M316.755 130.085C315.047 128.378 312.277 128.378 310.56 130.085C308.852 131.792 308.852 134.567 310.56 136.274C312.277 137.981 315.047 137.981 316.755 136.274C318.463 134.567 318.463 131.792 316.755 130.085Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 142.464C302.658 140.757 299.888 140.757 298.172 142.464C296.464 144.171 296.464 146.947 298.172 148.653C299.88 150.36 302.658 150.36 304.366 148.653C306.075 146.947 306.075 144.171 304.366 142.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M291.978 154.843C290.269 153.136 287.5 153.136 285.783 154.843C284.067 156.55 284.067 159.326 285.783 161.033C287.492 162.74 290.269 162.74 291.978 161.033C293.686 159.326 293.686 156.55 291.978 154.843Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 167.222C277.881 165.515 275.111 165.515 273.394 167.222C271.686 168.929 271.686 171.705 273.394 173.412C275.103 175.119 277.873 175.119 279.589 173.412C281.297 171.705 281.297 168.929 279.589 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M267.2 179.601C265.492 177.894 262.722 177.894 261.006 179.601C259.298 181.308 259.298 184.084 261.006 185.791C262.714 187.498 265.492 187.498 267.2 185.791C268.909 184.084 268.909 181.308 267.2 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M254.811 191.98C253.102 190.273 250.332 190.273 248.616 191.98C246.908 193.687 246.908 196.463 248.616 198.17C250.324 199.877 253.102 199.877 254.811 198.17C256.519 196.463 256.519 193.687 254.811 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M236.235 204.359C234.527 206.066 234.527 208.842 236.235 210.549C237.944 212.256 240.721 212.256 242.43 210.549C244.138 208.842 244.138 206.066 242.43 204.359C240.721 202.652 237.952 202.652 236.235 204.359Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M335.339 86.7659C336.68 88.1059 338.684 88.393 340.304 87.6273C338.404 86.9174 336.488 86.2794 334.557 85.7051C334.756 86.0879 335.02 86.4469 335.339 86.7659Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M329.145 92.9555C327.436 91.2406 324.666 91.2406 322.95 92.9555C321.242 94.6624 321.242 97.4381 322.95 99.145C324.658 100.852 327.436 100.852 329.145 99.145C330.853 97.4381 330.853 94.6624 329.145 92.9555Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M316.755 105.335C315.047 103.628 312.277 103.628 310.56 105.335C308.852 107.041 308.852 109.817 310.56 111.524C312.277 113.231 315.047 113.231 316.755 111.524C318.463 109.817 318.463 107.041 316.755 105.335Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 117.706C302.658 115.999 299.888 115.999 298.172 117.706C296.464 119.413 296.464 122.188 298.172 123.895C299.88 125.602 302.658 125.602 304.366 123.895C306.075 122.188 306.075 119.413 304.366 117.706Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M291.978 130.085C290.269 128.378 287.5 128.378 285.783 130.085C284.067 131.792 284.067 134.567 285.783 136.274C287.492 137.981 290.269 137.981 291.978 136.274C293.686 134.567 293.686 131.792 291.978 130.085Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 142.464C277.881 140.757 275.111 140.757 273.394 142.464C271.686 144.171 271.686 146.947 273.394 148.653C275.103 150.36 277.873 150.36 279.589 148.653C281.297 146.947 281.297 144.171 279.589 142.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M267.2 154.851C265.492 153.144 262.722 153.144 261.006 154.851C259.298 156.558 259.298 159.334 261.006 161.041C262.714 162.747 265.492 162.747 267.2 161.041C268.909 159.334 268.909 156.558 267.2 154.851Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M254.818 167.222C253.11 165.515 250.34 165.515 248.624 167.222C246.916 168.929 246.916 171.705 248.624 173.412C250.332 175.119 253.11 175.119 254.818 173.412C256.527 171.705 256.527 168.929 254.818 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M242.422 179.601C240.714 177.894 237.944 177.894 236.227 179.601C234.519 181.308 234.519 184.084 236.227 185.791C237.936 187.498 240.714 187.498 242.422 185.791C244.13 184.084 244.13 181.308 242.422 179.601Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M230.041 191.98C229.291 191.231 228.333 190.808 227.359 190.72C228.062 193.296 228.892 195.841 229.842 198.361C229.914 198.298 229.978 198.242 230.049 198.178C231.758 196.471 231.758 193.695 230.049 191.988L230.041 191.98Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M310.561 86.7659C312.278 88.4728 315.048 88.4728 316.756 86.7659C317.905 85.6173 318.273 83.9981 317.881 82.5384C315.104 82.2912 312.318 82.1795 309.532 82.1955C308.981 83.7429 309.316 85.5296 310.553 86.7659H310.561Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M304.366 92.9555C302.658 91.2406 299.888 91.2406 298.172 92.9555C296.464 94.6624 296.464 97.4381 298.172 99.145C299.88 100.852 302.658 100.852 304.366 99.145C306.075 97.4381 306.075 94.6624 304.366 92.9555Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M291.978 105.335C290.269 103.628 287.5 103.628 285.783 105.335C284.067 107.041 284.067 109.817 285.783 111.524C287.492 113.231 290.269 113.231 291.978 111.524C293.686 109.817 293.686 107.041 291.978 105.335Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 117.714C277.881 116.007 275.111 116.007 273.394 117.714C271.686 119.421 271.686 122.196 273.394 123.903C275.103 125.61 277.873 125.61 279.589 123.903C281.297 122.196 281.297 119.421 279.589 117.714Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M267.2 130.085C265.492 128.378 262.722 128.378 261.006 130.085C259.298 131.792 259.298 134.567 261.006 136.274C262.714 137.981 265.492 137.981 267.2 136.274C268.909 134.567 268.909 131.792 267.2 130.085Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M254.818 142.464C253.11 140.757 250.34 140.757 248.624 142.464C246.916 144.171 246.916 146.947 248.624 148.653C250.332 150.36 253.11 150.36 254.818 148.653C256.527 146.947 256.527 144.171 254.818 142.464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M242.422 154.851C240.714 153.144 237.944 153.144 236.227 154.851C234.519 156.558 234.519 159.334 236.227 161.041C237.936 162.747 240.714 162.747 242.422 161.041C244.13 159.334 244.13 156.558 242.422 154.851Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M230.041 167.222C228.476 165.659 226.034 165.531 224.318 166.823C224.286 169.2 224.349 171.585 224.509 173.954C226.209 175.095 228.54 174.911 230.041 173.412C231.749 171.705 231.749 168.929 230.041 167.222Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M285.792 86.7659C287.5 88.4728 290.278 88.4728 291.986 86.7659C292.792 85.9603 293.215 84.9154 293.255 83.8625C290.517 84.4129 287.803 85.0909 285.121 85.9045C285.305 86.2076 285.52 86.5027 285.784 86.7659H285.792Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 92.9555C277.881 91.2406 275.111 91.2406 273.394 92.9555C271.686 94.6624 271.686 97.4381 273.394 99.145C275.103 100.852 277.873 100.852 279.589 99.145C281.297 97.4381 281.297 94.6624 279.589 92.9555Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M267.208 105.335C265.5 103.628 262.73 103.628 261.014 105.335C259.305 107.041 259.305 109.817 261.014 111.524C262.722 113.231 265.5 113.231 267.208 111.524C268.916 109.817 268.916 107.041 267.208 105.335Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M254.818 117.714C253.11 116.007 250.34 116.007 248.624 117.714C246.916 119.421 246.916 122.196 248.624 123.903C250.332 125.61 253.11 125.61 254.818 123.903C256.527 122.196 256.527 119.421 254.818 117.714Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M242.422 130.085C240.714 128.378 237.944 128.378 236.227 130.085C234.519 131.792 234.519 134.567 236.227 136.274C237.936 137.981 240.714 137.981 242.422 136.274C244.13 134.567 244.13 131.792 242.422 130.085Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M230.041 148.654C231.749 146.947 231.749 144.171 230.041 142.464C229.586 142.009 229.051 141.682 228.492 141.467C227.598 144.235 226.84 147.042 226.233 149.874C227.582 150.097 229.003 149.69 230.041 148.654Z",
    fill: "#67CFEE"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9316 254.106H95.7822C93.2677 254.106 91.2161 252.056 91.2161 249.543V248.395C91.2161 245.882 93.2677 243.832 95.7822 243.832H96.9316C99.4461 243.832 101.498 245.882 101.498 248.395V249.543C101.498 252.056 99.4461 254.106 96.9316 254.106ZM75.4347 252.319L75.0435 251.234C74.1814 248.873 71.5472 247.645 69.1923 248.506L68.1067 248.897C65.7438 249.759 64.5145 252.391 65.3766 254.744L65.7678 255.828C66.6299 258.189 69.2642 259.418 71.619 258.556L72.7046 258.166C75.0675 257.304 76.2968 254.672 75.4347 252.319ZM51.8941 263.837L51.1518 262.951C49.5393 261.029 46.6416 260.774 44.7178 262.385L43.8318 263.127C41.908 264.738 41.6525 267.633 43.265 269.556L44.0074 270.441C45.6199 272.363 48.5175 272.618 50.4413 271.007L51.3274 270.266C53.2512 268.654 53.5066 265.759 51.8941 263.837ZM33.7179 282.708L32.7201 282.134C30.5408 280.882 27.739 281.632 26.4777 283.801L25.903 284.798C24.6497 286.976 25.4001 289.775 27.5713 291.036L28.5691 291.61C30.7484 292.862 33.5503 292.112 34.8115 289.943L35.3862 288.946C36.6395 286.768 35.8891 283.969 33.7179 282.708ZM23.0931 306.653L21.9596 306.454C19.485 306.015 17.1062 307.682 16.6672 310.155L16.4676 311.287C16.0286 313.76 17.6969 316.137 20.1715 316.575L21.305 316.775C23.7796 317.214 26.1584 315.547 26.5975 313.074L26.797 311.941C27.2361 309.469 25.5677 307.092 23.0931 306.653ZM21.305 332.783L20.1715 332.983C17.6969 333.421 16.0286 335.798 16.4676 338.271L16.6672 339.403C17.1062 341.876 19.485 343.543 21.9596 343.104L23.0931 342.905C25.5677 342.466 27.2361 340.089 26.797 337.617L26.5975 336.484C26.1584 334.012 23.7796 332.345 21.305 332.783ZM28.5691 357.948L27.5713 358.522C25.3921 359.775 24.6417 362.582 25.903 364.76L26.4777 365.757C27.731 367.934 30.5408 368.684 32.7201 367.424L33.7179 366.85C35.8971 365.597 36.6475 362.79 35.3862 360.612L34.8115 359.615C33.5582 357.438 30.7484 356.688 28.5691 357.948ZM44.0074 379.109L43.265 379.994C41.6525 381.917 41.9 384.812 43.8318 386.423L44.7178 387.165C46.6416 388.776 49.5393 388.529 51.1518 386.599L51.8941 385.713C53.5066 383.791 53.2592 380.896 51.3274 379.285L50.4413 378.543C48.5175 376.932 45.6199 377.179 44.0074 379.109ZM65.7598 393.722L65.3687 394.806C64.5065 397.167 65.7359 399.799 68.0987 400.653L69.1843 401.044C71.5472 401.905 74.1814 400.677 75.0355 398.316L75.4267 397.231C76.2888 394.87 75.0595 392.238 72.6966 391.385L71.611 390.994C69.2482 390.132 66.6139 391.361 65.7598 393.722ZM91.2002 400.015V401.163C91.2002 403.676 93.2517 405.726 95.7662 405.726H96.9157C99.4302 405.726 101.482 403.676 101.482 401.163V400.015C101.482 397.502 99.4302 395.452 96.9157 395.452H95.7662C93.2517 395.452 91.2002 397.502 91.2002 400.015ZM117.263 397.239L117.654 398.324C118.516 400.685 121.151 401.913 123.506 401.052L124.591 400.661C126.954 399.799 128.183 397.167 127.321 394.814L126.93 393.73C126.068 391.369 123.434 390.14 121.079 391.002L119.993 391.393C117.63 392.254 116.401 394.886 117.263 397.239ZM140.804 385.721L141.546 386.607C143.159 388.529 146.056 388.784 147.98 387.173L148.866 386.431C150.79 384.82 151.045 381.925 149.433 380.002L148.69 379.117C147.078 377.195 144.18 376.94 142.257 378.551L141.37 379.293C139.447 380.904 139.191 383.799 140.804 385.721ZM158.98 366.85L159.978 367.424C162.157 368.676 164.959 367.926 166.22 365.757L166.795 364.76C168.048 362.582 167.298 359.783 165.127 358.522L164.129 357.948C161.949 356.696 159.148 357.446 157.886 359.615L157.312 360.612C156.058 362.79 156.809 365.589 158.98 366.85ZM169.605 342.905L170.738 343.104C173.213 343.543 175.592 341.876 176.031 339.403L176.23 338.271C176.669 335.798 175.001 333.421 172.526 332.983L171.393 332.783C168.918 332.345 166.539 334.012 166.1 336.484L165.901 337.617C165.462 340.089 167.13 342.466 169.605 342.905ZM171.393 316.775L172.526 316.575C175.001 316.137 176.669 313.76 176.23 311.287L176.031 310.155C175.592 307.682 173.213 306.015 170.738 306.454L169.605 306.653C167.13 307.092 165.462 309.469 165.901 311.941L166.1 313.074C166.539 315.547 168.918 317.214 171.393 316.775ZM164.129 291.61L165.127 291.036C167.306 289.783 168.056 286.976 166.795 284.798L166.22 283.801C164.967 281.624 162.157 280.874 159.978 282.134L158.98 282.708C156.801 283.961 156.05 286.768 157.312 288.946L157.886 289.943C159.14 292.12 161.949 292.87 164.129 291.61ZM148.69 270.449L149.433 269.564C151.045 267.641 150.798 264.746 148.866 263.135L147.98 262.393C146.056 260.782 143.159 261.029 141.546 262.959L140.804 263.845C139.191 265.767 139.439 268.662 141.37 270.274L142.257 271.015C144.18 272.626 147.078 272.379 148.69 270.449ZM126.938 255.836L127.329 254.752C128.191 252.391 126.962 249.759 124.599 248.905L123.514 248.514C121.151 247.653 118.516 248.881 117.662 251.242L117.271 252.327C116.409 254.688 117.638 257.32 120.001 258.174L121.087 258.564C123.45 259.426 126.084 258.197 126.938 255.836Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M855.561 -236.297C860.015 -232.03 860.167 -224.963 855.896 -220.512L456.529 195.855C452.259 200.306 445.186 200.458 440.732 196.19C436.278 191.923 436.126 184.856 440.397 180.405L839.763 -235.962C844.034 -240.413 851.107 -240.564 855.561 -236.297ZM413.496 225.064C417.942 229.324 424.998 229.172 429.261 224.729C433.524 220.286 433.372 213.236 428.926 208.976C424.48 204.717 417.423 204.868 413.16 209.311C408.898 213.754 409.049 220.805 413.496 225.064Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M506.185 203.939C497.803 195.907 497.516 182.611 505.554 174.227L1257.04 -609.254C1265.08 -617.629 1278.38 -617.916 1286.77 -609.884C1295.16 -601.852 1295.44 -588.555 1287.4 -580.172L535.912 203.309C527.873 211.684 514.566 211.971 506.177 203.939H506.185Z",
    fill: "#67CFEE"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M209.845 221.858C218.954 221.858 226.337 214.48 226.337 205.379C226.337 196.278 218.954 188.9 209.845 188.9C200.737 188.9 193.354 196.278 193.354 205.379C193.354 214.48 200.737 221.858 209.845 221.858Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M146.839 293.74C167.304 293.74 183.894 277.163 183.894 256.714C183.894 236.265 167.304 219.688 146.839 219.688C126.374 219.688 109.784 236.265 109.784 256.714C109.784 277.163 126.374 293.74 146.839 293.74Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDesktopResultPage);
export default __webpack_public_path__ + "static/media/topDesktopResultPage.3f54236d37a447f7be9db1a51db80eed.svg";
export { ForwardRef as ReactComponent };